import styled from 'styled-components';

interface SSOImgProps {
  width?: string;
  height?: number | string;
  $padding?: string;
  $noAbsolute?: boolean;
}

export const SSOImg = styled.img<SSOImgProps>`
  width: ${(props) => (props.width ? props.width : '36px')};
  height: ${(props) =>
    props.height != null
      ? typeof props.height === 'number'
        ? `${props.height}px`
        : props.height
      : 'auto'};
  position: ${(props) => (props.$noAbsolute ? 'relative' : 'absolute')};
  left: ${(props) => (props.$noAbsolute ? 'auto' : '5px')};
  top: ${(props) => (props.$noAbsolute ? 'auto' : '50%')};
  transform: ${(props) => (props.$noAbsolute ? 'none' : 'translateY(-50%)')};
  box-shadow: rgba(0, 0, 0, 0.05) 10px 10px 20px 0px;
  border-radius: 50%;
  padding: ${(props) => (props.$padding ? props.$padding : '0')};
`;
